module.exports = __webpack_public_path__ + "img/attack_goldendragon.268634d5.png";